module.exports = __webpack_public_path__ + "static/brendan-0e6b5e87fb08b17fe96983ea96b049cf.jpg";